import React from "react";
import "./MyLineChart.css";
import {
  CartesianGrid,
  Line,
  LineChart,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";

const MyLineChart = ({ data }) => {
  return (
    <div>
      <div>
        <h1 className="caption">MONTH WISE SELL</h1>
      </div>
      <div>
        <LineChart width={600} height={400} data={data}>
          <Line
            type="monotone"
            dataKey={"revenue"}
            stroke={"gray"}
            strokeWidth={3}
          ></Line>
          <XAxis dataKey={"month"}></XAxis>
          <YAxis></YAxis>
          <CartesianGrid stroke="#ccc"></CartesianGrid>
          <Tooltip></Tooltip>
        </LineChart>
      </div>
    </div>
  );
};

export default MyLineChart;
